export function shipmentInProcessValidate(shipment_in_process){
    var result = true;

    result = validateId(shipment_in_process.id);
    if(!result) return result;
    result = validateTraceId(shipment_in_process.trace_id);
    if(!result) return result;
    result = validateShipments(shipment_in_process.shipments);
    if(!result) return result;
    
    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateTraceId(trace_id){
    if(typeof trace_id === 'string' && trace_id.trim() !== '') return true;
    else return false;
}

function validateShipments(shipments){
    if(typeof shipments === 'string' && shipments.trim() !== '') return true;
    else return false;
}